import styled from '@emotion/styled'

export const Container = styled.div({
  textAlign: 'center',
  // height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  
  // '.font-landing': {
  //   fontWeight: 'bolder',
  //   fontSize: '50px'
  // },

  // '.font-landing-2': {
  //   fontSize: '30px'
  // },

  // '.flex-container': {
  //   display: 'flex',
  //   flexWrap: 'wrap'
  // },
  
  // '.flex-container > div': {
  //   margin: '10px',
  //   padding: '20px',
  // }


})
